// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];

const accountApi = {
  getAccount() {
    return client.get('/account/accounts')
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  updateAccount(payload) {
    return client.patch(`/account/accounts/${payload.id}`, payload)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  updateAvatarColour(payload) {
    const { avatarColour } = payload;
    return client.patch(`/account/accounts/${payload.id}`, { properties: { avatarColour } })
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getAdvertiserInvoicingDetails(payload) {
    return client.get(`/account/a/${payload.id}/invoicing-details`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getAgencyInvoicingDetails(agencyId) {
    return client.get(`/account/agencies/${agencyId}/invoicing-details`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getAccountsInvoicingDetails(accountId) {
    return client.get(`/account/accounts/${accountId}/invoicing-details`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getCampaignInvoicingDetails(campaignId) {
    return client.get(`/account/campaigns/${campaignId}/invoicing-details`)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postAdvertiserInvoicingDetails(payload) {
    return client.post(`/account/a/${payload.id}/invoicing-details`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postAgencyInvoicingDetails(payload) {
    return client.post(`/account/agencies/${payload.id}/invoicing-details`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  postAccountsInvoicingDetails(payload) {
    return client.post(`/account/accounts/${payload.id}/invoicing-details`, payload.body)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  putInvoicingDetails(payload, campaignId, invoicingId) {
    return client.put(`/account/campaigns/${campaignId}/invoicing-details/${invoicingId}`, payload)
      .then((response) => response.data).catch((error) => {
        throw error;
      });
  },
  getAccountById(accountId) {
    return client.get(`/account/accounts/${accountId}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getUsersByRole(role) {
    return client.get(`/account/users?role=${role}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getUserEmailExists(email) {
    return client.head(`/account/accounts?email=${email}`)
      .then((response) => response.status)
      .catch((error) => {
        throw error;
      });
  },
  fetchReportAdvertisers(payload) {
    return client.get(`/account/a?campaignStates=${payload.states.join(',')}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  fetchReportSharedAdvertisers(payload) {
    return client.get(`/account/a/shared?campaignStates=${payload.states.join(',')}&shareTypes=REPORTING,CAMPAIGN`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  fetchSharedAdvertisers() {
    return client.get('/account/a/shared')
      .then((response) => response.data);
  },
};
export default accountApi;
